import moduleConstructors from "./constructors";

const setProductFormDetails = (state, payload) => {
  state.productDetailsForm = moduleConstructors.initProductData(payload);
};

export default {
  setProductFormDetails,
};
